export const MAX_ANSWER_LENGTH = 1024;
